import moment from 'moment';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { IData } from './interfaces';

interface IBarChart {
  data: IData[];
  hasOneData?: boolean;
  firstValueColor?: string;
  secondValueColor?: string;
  labelForOneData?: string;
  labelForTwoDatas?: ILabelForDatas;
}

interface ILabelForDatas {
  firstLabel: string;
  secondLabel: string;
}

function BarChart(props: IBarChart) {
  let data: IData;
  let array: any[] = [];
  let received: any[] = [];
  let paid: any[] = [];
  let arrayOfDates: any[] = [''];

  if (props.hasOneData === true) {
    array = props.data.map((values: IData) => {
      return values.faresReceived === undefined
        ? 0
        : values.faresReceived.value;
    });
  } else {
    paid = props.data.map((values: IData) => {
      return values.faresPassedOn === undefined
        ? 0
        : values.faresPassedOn.value;
    });
    received = props.data.map((values: IData) => {
      return values.faresReceived === undefined
        ? 0
        : values.faresReceived.value;
    });
  }

  arrayOfDates = props.data.map((dates: IData) => {
    const formattedDate = moment(dates.date).format('MM/YY');
    return formattedDate;
  });

  if (props.hasOneData === false) {
    data = {
      labels: arrayOfDates.reverse(),
      datasets: [
        {
          label: props.labelForTwoDatas?.firstLabel,
          data: received.reverse(),
          backgroundColor: props.firstValueColor,
        },
        {
          label: props.labelForTwoDatas?.secondLabel,
          data: paid.reverse(),
          backgroundColor: props.secondValueColor,
        },
      ],
    };
  } else {
    data = {
      labels: arrayOfDates.reverse(),
      datasets: [
        {
          label: props.labelForOneData,
          data: array.reverse(),
          backgroundColor: props.firstValueColor,
        },
      ],
    };
  }

  return (
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      <Bar
        data={data}
        options={{
          responsive: true,
          tooltips: {
            mode: 'index',
          },
          maintainAspectRatio: false,
          legend: {
            labels: {
              fontSize: 12,
              padding: 0,
            },
            position: 'bottom',
          },
          scales: {
            xAxes: [
              {
                stacked: false,
              },
            ],
            yAxes: [
              {
                stacked: false,
                ticks: {
                  min: 0,
                  display: true,
                  beginAtZero: true,
                  autoSkipPadding: 10,
                },
              },
            ],
          },
        }}
      />
    </div>
  );
}

export default BarChart;
